var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"my-projects-button-area"},[_c(_setup.BCXItemsWithPoints,{attrs:{"gap":"12px","remove-wrapping-points":""}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }